module.exports = __webpack_public_path__ + "img/goresam.a6cd8826.png";